
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UIDefinitionBox',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Definition title'
    },
    text: {
      type: String,
      default: 'Definition text'
    }
  },
  data() {
    return {
      expand: this.isOpen || false
    }
  }
})
